/**
 * @expFlag auth-mobile-redirect-app-main-actions
 * @ticket CLOUDWEB-20237
 * @file
 */
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { ANONYM_USER, IS_B2B_BIZ_USER, IS_IOS_MOBILE, IS_MOBILE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

type authMobileRedirectAppMainActionsType = {
    type: 'a' | 'b' | 'c' | 'd';
    href: string;
    timeout?: number;
};

export const abAuthMobileRedirectAppMainActions: false | authMobileRedirectAppMainActionsType =
    !IS_WEBVIEW &&
    IS_MOBILE_BROWSER &&
    !IS_B2B_BIZ_USER &&
    !ANONYM_USER &&
    !IS_IOS_MOBILE &&
    getFeature(`auth-mobile-redirect-app-main-actions`);
